import { useState } from "react";
import { useReversalService } from "../../service/reversal";
import { useNotificationSnackbar } from "../useNotificationSnackbar";

export interface ClientInfo {
  documentClient: string;
  nameClient: string;
  email: string;
  phoneClient: string;
}

export interface FormInfo {
  comentario: string;
  qualOMotivoDoCancelamento: string;
  emQueDataOPedidoFoiFeito: string;
  emQualLojaOSeuPedidoFoiFeito: string;
  numeroDoPedido: string;
  qualFoiOProblemaComOSeuPedido: string;
  seuPedidoFoiRealizadoVia: string;
  voceRecebeuSeuPedido: string;
  qualItemFaltouEmSeuPedidoOuFoiEnviadoIncorretamente: string;
  informeOValorASerEstornado: string;
  franqueado: number;
  estornado: string;
  motivoEstorno: string;
  faq: string;
  dataFaq: string;
  dataForm: string;
  fila?: string;
}

export interface RequestData {
  clientInfo: ClientInfo;
  formInfo: FormInfo;
  idTask: number;
  idCase: number;
  login: string;
  id: number | string;
  totalRows: number;
}

const useGetAllReversal = (filter: any) => {
  const [data, setData] = useState<RequestData[]>([]);
  const [error, setError] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { onErrorSnackbar } = useNotificationSnackbar();
  const { getReversal } = useReversalService();

  const fetchData = async () => {
    try {
      setData([]);
      if (filter.loginUser) {
        setIsLoading(true);
        const response = await getReversal(filter);
        if (response?.status === 200) {
          setData(response?.data);
        } else {
          onErrorSnackbar(response?.data);
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const refresh = () => {
    fetchData();
  };

  return {
    data,
    error,
    isLoading,
    refresh,
  };
};

export default useGetAllReversal;
